export enum OD_BACKEND_ROUTES {
  files = '/files',
  backgroundAnimations = '/background-animations',
}
